import { GenericModal } from 'components/GenericModal';
import {
  EtapaProjeto,
  StatusEtapa,
  StatusEtapaResponseDTO,
} from 'models/projeto';
import moment from 'moment';
import { Fragment, useCallback, useMemo } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from 'store/modules/ModalActions';
import languageValues from 'utils/LanguageUtils';
import styles from './historicoModal.scss';
const { rootClassName } = styles;

interface Props {
  modalKey: string;
  historico: StatusEtapaResponseDTO;
  etapa: EtapaProjeto;
  flgInfantil: boolean;
}

export default function HistoricoModal(props: Props) {
  const d = useDispatch();

  const name = useMemo(() => {
    const item = languageValues.pages.projetos.etapas[props.etapa].name;
    if (typeof item === 'function') {
      return item(props.flgInfantil);
    }
    return item;
  }, [props.etapa, props.flgInfantil]);

  const statusChip = useCallback((status: StatusEtapa) => {
    return (
      <div className={`${rootClassName}-status status-${status}`}>
        {languageValues.pages.projetos.statusEtapa[status]}
      </div>
    );
  }, []);

  return (
    <GenericModal
      onClose={() => {
        d(closeModal(props.modalKey));
      }}
      title={
        <Fragment>
          {languageValues.modals.historicoModal.title}
          <br />
          <small>{name}</small>
        </Fragment>
      }
      DialogProps={{ className: rootClassName }}
    >
      <div className={`${rootClassName}-messages`}>
        {props.historico.historico
          .slice()
          .sort((a, b) => {
            return moment(a.dataCadastro).isSameOrBefore(moment(b.dataCadastro))
              ? 1
              : -1;
          })
          .map((m, i) => {
            return (
              <div className={`${rootClassName}-message`} key={i}>
                <div className={`${rootClassName}-status-row`}>
                  {statusChip(m.status)}
                  {moment(m.dataCadastro).format('DD/MM/YYYY HH:mm')}
                </div>
                <div className={`${rootClassName}-name-row`}>
                  {[
                    languageValues.modals.historicoModal.por,
                    m.nomeAssessor,
                  ].join(' ')}
                </div>
                <div className={`${rootClassName}-text-row`}>
                  {m.comentario}
                </div>
              </div>
            );
          })}
      </div>
    </GenericModal>
  );
}
